import { useSubscribe } from "@/src/lib/actions";
import { useState } from "react";

export function usePageChange() {
  const [page, setPage] = useState(1);

  useSubscribe<number>("ych:page", setPage);

  return page;
}

export function usePageSize() {
  const [pageSize, setPageSize] = useState(40);

  useSubscribe<number>("ych:page-size", setPageSize);

  return pageSize;
}

export function useSearch() {
  const [search, setSearch] = useState("");

  useSubscribe<string>("ych:search", setSearch);

  return search;
}

export function useSorting() {
  const [sorting, setSorting] = useState("priceASC");

  useSubscribe<string>("ych:sorting", setSorting);

  return sorting;
}
